import { Link } from "react-router-dom"
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Heart } from "lucide-react"

export default function Footer() {
  return (
    <footer className="bg-blue-50 text-gray-800">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {/* Organization Info */}
      <div className="lg:col-span-2">
        <h3 className="text-2xl font-bold mb-4 text-blue-900">आपले आरोग्य आपल्या हाती</h3>
        <p className="text-blue-700 mb-6 max-w-md">
          आरोग्य संवर्धन आणि जनजागृतीसाठी समर्पित संस्था. आम्ही लोकांना निरोगी ठेवण्यासाठी विविध सेवा पुरवतो.
        </p>
        <div className="flex space-x-4">
          <a href="https://www.facebook.com/p/Dr-Bharat-Nandure-Smart-Hair-Transplant-Clinic-Parbhani-100087796573929/" className="text-blue-700 hover:text-blue-900 transition-colors">
            <Facebook className="w-6 h-6" />
          </a>
          <a href="https://share.google/1Gp3D8PieOMMjCcfj" className="text-blue-700 hover:text-blue-900 transition-colors">
            <Twitter className="w-6 h-6" />
          </a>
          <a href="https://share.google/1Gp3D8PieOMMjCcfj" className="text-blue-700 hover:text-blue-900 transition-colors">
            <Instagram className="w-6 h-6" />
          </a>
        </div>
      </div>

      {/* Quick Links */}
      <div>
        <h4 className="text-lg font-semibold mb-4 text-blue-900">द्रुत दुवे</h4>
        <ul className="space-y-2">
          <li>
            <Link to="/" className="text-blue-700 hover:text-blue-900 transition-colors">
              मुख्यपृष्ठ
            </Link>
          </li>
          <li>
            <Link to="/register" className="text-blue-700 hover:text-blue-900 transition-colors">
              सदस्य नोंदणी
            </Link>
          </li>
          <li>
            <Link to="/videos" className="text-blue-700 hover:text-blue-900 transition-colors">
              आरोग्य शिक्षण
            </Link>
          </li>
          <li>
            <Link to="/member/login" className="text-blue-700 hover:text-blue-900 transition-colors">
              सदस्य लॉगिन
            </Link>
          </li>
        </ul>
      </div>

      {/* Contact Info */}
      <div>
        <h4 className="text-lg font-semibold mb-4 text-blue-900">संपर्क माहिती</h4>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <Phone className="w-5 h-5 text-blue-400" />
            <span className="text-blue-700">+91 98233 84540</span>
          </div>
          <div className="flex items-center space-x-3">
            <Mail className="w-5 h-5 text-blue-400" />
            <span className="text-blue-700">info@aplearogyaaplyahati.org</span>
          </div>
          <div className="flex items-start space-x-3">
            <MapPin className="w-5 h-5 text-blue-400 mt-1" />
            <span className="text-blue-700">
              मुख्य कार्यालय,
              <br />
              स्मार्ट हेअर ट्रान्सप्लांट आणि कॉस्मेटिक क्लिनिक, परभणी, महाराष्ट्र
            </span>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom Bar */}
    <div className="border-t border-blue-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center space-x-2 text-blue-700">
        <span>© 2025 आपले आरोग्य आपल्या हाती. सर्व हक्क राखीव.</span>
      </div>
      <div className="flex items-center space-x-2 text-blue-700 mt-4 md:mt-0">
        <span>Made with</span>
        <Heart className="w-4 h-4 text-red-500" />
        <span>for Health Awareness & Wellness</span>
      </div>
    </div>
  </div>
</footer>

  )
}
